


export enum TipoCertificacaoEnum {
    RECURSO = 'RECURSO',
    FERRAMENTA_AUTORIA = 'FERRAMENTA_AUTORIA',
}